import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import { BrowserRouter } from 'react-router-dom';
import { getApiContext } from './service/api';

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename={getApiContext()}>
            <App/>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
